export default {
  app: {
    featured: 'مميّز',
    random: 'عشوائي',
    explore: 'اكتشف',
    keywords: 'الكلمات المفاتيح',
    search: 'ابحث',
  },
  explore: {
    filters: 'المرشحات',
    resetFilters: 'إعادة ضبط المرشحات',
    addKeyword: 'إضافة الكلمات المفاتيح',
  },
  recipe: {
    contributedBy: 'تمّت المساهمة بواسطة',
    ingredients: 'المكوّنات',
    directions: 'كيفيّة التّحضير',
    fullRecipe: 'عرض الوصفة كاملة على',
    similarDrinks: 'مشروبات مماثلة',
  },
  featuredRecipes: {
    loadMore: 'حمّل المزيد',
  },
  recipeFind: {
    filterBy: 'صنّف حسب',
    name: 'الإسم',
    ingredients: 'المكوّنات',
    keywords: 'الكلمات المفاتيح',
    searchForIngredients: 'يمكنك البحث عن مكونات متعددة عن طريق فصلها بمسافة',
    searchForKeywords: 'يمكنك البحث عن عدة كلمات رئيسية عن طريق فصلها بمسافة',
  },
  recipeList: {
    viewRecipe: 'شاهد الوصفة',
  },
  recipeToolbar: {
    print: 'إطبع',
    share: 'شارك',
    shareOnFacebook: 'شارك على الفيسبوك',
    shareOnTwitter: 'شارك على التويتر',
    copyURL: 'إنسخ الرابط',
    hideImage: 'إخفاء الصورة',
  },
  favorites: {
    removeAllFavorites: 'إزالة كافة المفضّلات',
    noFavoriteDrinks: 'ليس لديك أي مشروبات مفضلة',
    removeFavoritesPrompt: 'هل أنت متأكد أنك تريد إزالة كافة المفضّلات',
    delete: 'حذف',
    cancel: 'إلغاء',
  },
  search: {
    findYourDrink: 'ابحث عن مشروبك',
  },
  pageNotFound: {
    pageNotFound: 'الصفحة التي تبحث عنها غير موجودة',
    backToHome: 'العودة إلى الصّفحة الرّئيسيّة',
  },
};
